import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Skeleton } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { gql, useLazyQuery } from "@apollo/client";
import { useReactToPrint } from "react-to-print";
import Invoice from "@general/userPayment/invoice";

function InvoicesTableDetails({ invoiceId }) {
  const [invoiceDetails, setInvoiceDetails] = useState({});


  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    contentRef,
    onBeforeGetContent: async () => {
      await document.fonts.ready;
      try {
        await document.fonts.load('18px IRANSansXFaNum');
      } catch (e) {
        console.warn('font load failed', e);
      }
    },
    pageStyle: `
    @font-face {
      font-family: "IRANSansXFaNum";
      src: url("${window.location.origin}/fonts/woff2/IRANSansXFaNum-Regular.woff2") format("woff2");
    }
    .contract-wrapper,
    .contract-wrapper * {
      font-family: "IRANSansXFaNum" !important;
    }
  `,
  });

  const GETINVOICEDATA = gql`
    query GetInvoce($id: ID!) {
      getInvoice(id: $id) {
        id
        amountRial
        description
        createdAt
        finalAmount
        discountAmount
        user {
          gender
          name
        }
        paidAt
        cancelAt
        invoiceType
        startAt
        effectiveStartAt
        expectedEndAt
        package {
          id
          name
          days
        }
      }
    }
  `;
  const [getInvoiceData, invoiceData] = useLazyQuery(GETINVOICEDATA, {
    onError(error) {
      console.log(error.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
    onCompleted({ getInvoice }) {
      setInvoiceDetails(getInvoice);
    },
  });
  useEffect(() => {
    if (invoiceId) {
      getInvoiceData({ variables: { id: invoiceId } });
    }
  }, [invoiceId, invoiceDetails]);

  if (invoiceData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <>

      <Button type="primary" icon={<PrinterOutlined />} onClick={reactToPrintFn}>
        چاپ فاکتور
      </Button>

      <Invoice details={invoiceDetails} ref={contentRef} />
    </>
  );
}

export default InvoicesTableDetails;
